import * as React from 'react';
import * as Glob from '../Globale';
import { BottoneAPI, Trad } from '../components/';

interface IDati {
    Nome: string;
    Cognome: string;
}

export class Address extends React.Component<Glob.IRouteGlobaleProps, {}> {
    constructor(props: any) {
        super(props);

        var M = Glob.GetMenu();
        M.Main = "Home";
        M.ID_MenuMain = 3;
        this.props.SetMenu(M);
    }

    public render() {
        let Dati: IDati = { Nome: "Mirko", Cognome: "Sacripanti" };
       return <div>
                <h1>Welcome!</h1>
                <ul className="breadcrumb">
                    <li><a href="/dashboard"> Home</a></li>
                    <li><a href="#">Anagrafica</a></li>
                    <li className="active">Ricerca</li>
                </ul>
                <div className="btn-group">
                    <ul className="nav nav-tabs">
                        <li className="active"><a href="#">Ricerca</a></li>
                        <li><a href="#">{Trad.Trad("Inserisci")}</a></li>
                        <li><a href="#">{Trad.Trad("Consulta")}</a></li>
                    </ul>
                </div>
                <form className="navbar-form" method="GET" role="search">
                    <div className="form-group">
                        <label>Denominazione</label>
                        <input type="text" name="search" className="form-control field" placeholder="Denominazione" />
                        <label>Partita IVA</label>
                        <input type="text" name="search" className="form-control field" placeholder="Partita IVA" />
                        <label>Codice Fiscale</label>
                        <input type="text" name="search" className="form-control field" placeholder="Codice Fiscale" />
                        <label>Ragione Sociale</label>
                        <input type="text" name="search" className="form-control field" placeholder="Ragione Sociale" />
                        <label>Sede</label>
                        <input type="text" name="search" className="form-control field" placeholder="Sede" />
                    </div>
                    <div className="form-group">
                        <label>Tipologia</label>
                        <select className="form-control" id="exampleSelect2">
                            <option>Persona Fisica</option>
                            <option>Persona Giuridica</option>
                            <option>Ente</option>
                        </select>
                        <label>Stato</label>
                        <select className="form-control" id="exampleSelect2">
                            <option>Cliente</option>
                            <option>Ex Cliente</option>
                            <option>Richiesta riapertura</option>
                        </select>    <button type="submit" className="btn btn-primary"><div className="glyphicon glyphicon-search"></div></button><span className="fa fa-search"></span>
                    </div>       
                </form>      <hr />
                <table id="example" className="table table-striped table-responsive table-bordered">
                    <thead>
                        <tr>
                            <th>Denominazione <i className="glyphicon glyphicon-sort-by-attributes"></i></th>
                            <th>P.I/C.F.</th>
                            <th>Tipologia</th>
                            <th>Stato</th>
                            <th>Sede</th>
                            <th>POS collegato</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><a href="#">One S.r.l.</a></td>
                            <td>123456789</td>
                            <td>Srl</td>
                            <td>Cliente</td>
                            <td>Milano</td>
                            <td>POS 2</td>
                        </tr>
                        <tr>
                            <td><a href="#">Two S.p.A.</a></td>
                            <td>987654321</td>
                            <td>Spa</td>
                            <td>In acquisizione</td>
                            <td>Torino</td>
                            <td>POS 1</td>
                        </tr>
                        <tr>
                            <td><a href="#">Three Four</a></td>
                            <td>FROTHR25A42H501G</td>
                            <td>Persona Fisica</td>
                            <td>Contatto</td>
                            <td>Roma</td>
                            <td>POS 3</td>
                        </tr>
                    </tbody>
                </table>
            </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/Address.tsx